import { StyleSheet } from 'aphrodite';
import { THEME } from '@HoudiniUI/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.sm,
	},
	label: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
	},
	trigger: {
		minWidth: 220,
	},
});
